module.exports = __webpack_public_path__ + "static/media/Migration_Icon.c8d94175.svg";